<div class="ibox">
    <div class="ibox-content">
        <div class="row documentation">
            <div class="col-md-2">
                <ul class="documentation-nav">
                    <li [ngClass]="{ '_active': selectedTab === DocumentationTab.TAB_OBJECTIVE }">
                        <a (click)="clickOnTab(DocumentationTab.TAB_OBJECTIVE)">
                            <span [i18n]="'webhooks-events.documentation.objective.title'"></span>
                        </a>
                    </li>
                    <li [ngClass]="{ '_active': selectedTab === DocumentationTab.TAB_INTERFACE }">
                        <a (click)="clickOnTab(DocumentationTab.TAB_INTERFACE)">
                            <span [i18n]="'webhooks-events.documentation.interface.title'"></span>
                        </a>
                        <ul class="documentation-nav-sub" [hidden]="selectedTab !== DocumentationTab.TAB_INTERFACE">
                            <li>
                                <a (click)="clickOnTabItem(DocumentationAnchor.INTERFACE_CONFIGURATION)">
                                    Configuration
                                </a>
                            </li>
                            <li>
                                <a (click)="clickOnTabItem(DocumentationAnchor.INTERFACE_EVENT)">
                                    Event
                                </a>
                            </li>
                            <li>
                                <a (click)="clickOnTabItem(DocumentationAnchor.INTERFACE_EVENT_DETAILS)">
                                    Event Detail
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li [ngClass]="{ '_active': selectedTab === DocumentationTab.TAB_CALLBACK_URL }">
                        <a (click)="clickOnTab(DocumentationTab.TAB_CALLBACK_URL)">
                            The callback URL
                        </a>
                    </li>
                    <li [ngClass]="{ '_active': selectedTab === DocumentationTab.TAB_RETRY_POLICY }">
                        <a (click)="clickOnTab(DocumentationTab.TAB_RETRY_POLICY)">
                            The retry policy
                        </a>
                    </li>
                    <li [ngClass]="{ '_active': selectedTab === DocumentationTab.TAB_EVENTS }">
                        <a (click)="clickOnTab(DocumentationTab.TAB_EVENTS)">
                            The events
                        </a>
                        <ul class="documentation-nav-sub" [hidden]="selectedTab !== DocumentationTab.TAB_EVENTS">
                            <li>
                                <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_WRAP)">
                                    Common wrap
                                </a>
                            </li>
                            <li>
                                <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA)">
                                    Common Data
                                </a>
                                <ul>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)">
                                            Location
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TRIP_LOCATION)">
                                            TripLocation
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_COORDINATES)">
                                            Coordinates
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_ADDRESS)">
                                            Address
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TIMEINTERVAL)">
                                            TimeInterval
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_CARRIER)">
                                            Carrier
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOAD_DATA)">
                                            LoadData
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_FIELD_CHANGE)">
                                            FieldChange
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_DATE_RANGED)">
                                            DateRanged
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TYPED_DATE_RANGED)">
                                            TypedDateRanged
                                        </a>
                                    </li>
                                    <li>
                                    <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_SHIPMENT)">
                                            Trip Shipment
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_SHIPMENT_ITEMS)">
                                            Trip Shipment Items
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_LOCATION_CONTACT_DETAILS)">
                                            Trip Location Contact Details
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_TRAILER_DETAILS)">
                                            Trip Trailer Details
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY)">
                                    Delivery
                                </a>
                                <ul>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_CHECKIN)">
                                            CHECKIN
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_CHECKOUT)">
                                            CHECKOUT
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_ETA_UPDATE)">
                                            ETA_UPDATED
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_BOL_UPDATE)">
                                            BOL_UPDATED
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_TRIP_CREATE)">
                                            TRIP_CREATED
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_TRIP_UPDATE)">
                                            TRIP_UPDATE
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_TRIP_PATCH)">
                                            TRIP_PATCH
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_TRIP_CLOSED)">
                                            TRIP_CLOSED
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_DELIVERY_TRIP_CANCEL)">
                                            TRIP_CANCELLED
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_PGI)">
                                            PGI
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_FAILED_COLLECTION)">
                                            FAILED_COLLECTION
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_REVERSE_CHECKIN)">
                                            REVERSE_CHECKIN
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>


            <div class="col-md-10">
                <!-- START - TAB 1 -->
                <div class="row" [hidden]="selectedTab !== DocumentationTab.TAB_OBJECTIVE">
                    <div id="objectiveIndex" class="col-md-12 title">
                        <h1 [i18n]="'webhooks-events.documentation.objective.title'"></h1>
                        <hr>
                    </div>

                    <div class="col-md-12 documentation-item">
                        <p class="documentation-item-txt"
                           [i18n]="'webhooks-events.documentation.objective.textIntro'"></p>
                    </div>
                </div>
                <!-- END - TAB 1 -->

                <!-- START - TAB 2 -->
                <div class="row" [hidden]="selectedTab !== DocumentationTab.TAB_INTERFACE">
                    <div id="interfaceIndex" class="col-md-12 title">
                        <h1 [i18n]="'webhooks-events.documentation.interface.title'"></h1>
                        <hr>
                    </div>

                    <div class="col-md-12 documentation-item">
                        <p class="documentation-item-txt"
                           [i18n]="'webhooks-events.documentation.interface.textIntro'"></p>
                    </div>

                    <div [id]="DocumentationAnchor.INTERFACE_CONFIGURATION" class="col-md-12 subTitle">
                        <h2 [i18n]="'webhooks-events.documentation.interface.config.title'"></h2>
                        <br>
                    </div>

                    <div class="col-md-5 documentation-item">
                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.config.text1'"></span>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.config.text2'"></span><a href="#"
                                                                                                            [i18n]="'webhooks-events.documentation.interface.config.text2Link'"></a>)<span
                            [i18n]="'webhooks-events.documentation.interface.config.text2end'"></span>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.config.text3'"></span>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.config.text4'"></span>
                        </p>
                    </div>

                    <div class="col-md-1"></div>

                    <div class="col-md-6">
                        <img src="assets/screen-doc/screen-webhook-conf.png" width="100%">
                    </div>


                    <div [id]="DocumentationAnchor.INTERFACE_EVENT" class="col-md-12 subTitle">
                        <h2 [i18n]="'webhooks-events.documentation.interface.events.title'"></h2>
                        <br>
                    </div>

                    <div class="col-md-5 documentation-item">
                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.events.text1'"></span>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.events.text2'"></span><strong
                            [i18n]="'webhooks-events.documentation.interface.events.text2Link'"></strong> <span
                            [i18n]="'webhooks-events.documentation.interface.events.text2end'"></span>
                        </p>
                    </div>

                    <div class="col-md-1"></div>

                    <div class="col-md-6">
                        <img src="assets/screen-doc/screen-webhook-events.png" width="100%">
                    </div>

                    <div [id]="DocumentationAnchor.INTERFACE_EVENT_DETAILS" class="col-md-12 subTitle">
                        <h2 [i18n]="'webhooks-events.documentation.interface.events-details.title'"></h2>
                        <br>
                    </div>

                    <div class="col-md-5 documentation-item">
                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.events-details.text1'"></span>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.events-details.text2'"></span><a
                            href="#"> <span
                            [i18n]="'webhooks-events.documentation.interface.events-details.text2Link'"></span></a>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.interface.events-details.text3'"></span>
                        </p>
                    </div>

                    <div class="col-md-1"></div>

                    <div class="col-md-6">
                        <img src="assets/screen-doc/screen-webhook-events-details.png" width="100%">
                    </div>

                </div>
                <!-- END TAB 2 -->

                <!-- START - TAB 3 -->
                <div class="row" [hidden]="selectedTab !== DocumentationTab.TAB_CALLBACK_URL">
                    <div id="callBackIndex" class="col-md-12 title">
                        <h1 [i18n]="'webhooks-events.documentation.callback-url.title'"></h1>
                        <hr>
                    </div>

                    <div class="col-md-12 documentation-item">
                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.callback-url.textIntro1'"></span>
                        </p>

                        <ul>
                            <li><strong
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item1Bold'"></strong><span
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item1'"></span></li>
                            <li><strong
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item2Bold'"></strong><span
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item2'"></span></li>
                            <li><strong
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item3Bold'"></strong><span
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item3'"></span></li>
                        </ul>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.callback-url.textIntro2'"></span>
                        </p>

                        <ul>
                            <li><strong
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item1Bold'"></strong><span
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item1'"></span></li>
                            <li><strong
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item2Bold'"></strong><span
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item2'"></span></li>
                            <li><strong
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item3Bold'"></strong><span
                                [i18n]="'webhooks-events.documentation.callback-url.list1.item3'"></span></li>
                        </ul>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.callback-url.textIntro3'"></span>
                        </p>

                        <p class="documentation-item-txt"
                           [i18n]="'webhooks-events.documentation.callback-url.textIntro4'">
                        </p>
                    </div>
                </div>
                <!-- END - TAB 3 -->

                <!-- START - TAB 4 -->
                <div class="row" [hidden]="selectedTab !== DocumentationTab.TAB_RETRY_POLICY">
                    <div id="retryPolicyIndex" class="col-md-12 title">
                        <h1 [i18n]="'webhooks-events.documentation.retry-policy.title'"></h1>
                        <hr>
                    </div>

                    <div class="col-md-12 documentation-item">
                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.retry-policy.text1'"></span>
                        </p>


                        <p><span [i18n]="'webhooks-events.documentation.retry-policy.examples.title'"></span></p>
                        <div class="documentation-item-darkZone">
                            <h3 class="force-inner-space-top-0"
                                [i18n]="'webhooks-events.documentation.retry-policy.examples.retry'"></h3>
                            <br>
                            <p class="documentation-item-txt"
                               [i18n]="'webhooks-events.documentation.retry-policy.examples.retry1'">
                            </p>
                            <p class="documentation-item-txt"
                               [i18n]="'webhooks-events.documentation.retry-policy.examples.retry2'">
                            </p>
                        </div>

                        <div class="documentation-item-darkZone">
                            <h3 class="force-inner-space-top-0"
                                [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed'"></h3>
                            <br>
                            <p class="documentation-item-txt"
                               [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed1'">
                            </p>
                            <p class="documentation-item-txt"
                               [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed2'">
                            </p>
                            <p class="documentation-item-txt"
                               [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed3'">
                            </p>
                            <p class="documentation-item-txt"
                               [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed4'">
                            </p>
                            <p class="documentation-item-txt"
                               [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed5'">
                            </p>

                            <div class="subDarkZone">
                                <p class="documentation-item-txt"
                                   [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed6'">
                                </p>
                                <p class="documentation-item-txt"
                                   [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed7'">
                                </p>
                                <p class="documentation-item-txt"
                                   [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed8'">
                                </p>
                                <p class="documentation-item-txt"
                                   [i18n]="'webhooks-events.documentation.retry-policy.examples.fullFailed9'">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END - TAB 4 -->

                <!-- START - TAB 5 -->
                <div class="row" [hidden]="selectedTab !== DocumentationTab.TAB_EVENTS">
                    <div id="eventsIndex" class="col-md-12 title">
                        <h1 [i18n]="'webhooks-events.documentation.events.title'"></h1>
                        <hr>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_WRAP" class="col-md-12 subTitle">
                        <h2 [i18n]="'webhooks-events.documentation.events.common-wrap.title'"></h2>

                        <br>
                    </div>

                    <div class="col-md-12 documentation-item">
                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.events.common-wrap.text1'"></span>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.events.common-wrap.text2'"></span>
                        </p>

                        <p class="documentation-item-txt">
                            <span [i18n]="'webhooks-events.documentation.events.common-wrap.text3'"></span>
                        </p>

                        <div class="documentation-item-darkZone">
                            <p [i18n]="'webhooks-events.documentation.events.common-wrap.example1'"></p>
                            <pre class="eventData-code">{{ commonWrapExample | json}}</pre>
                        </div>
                    </div>


                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA" class="col-md-12 subTitle">
                        <h2 [i18n]="'webhooks-events.documentation.events.common-data.title'"></h2>
                        <br>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.location.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.type.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.type.description'"></td>
                                <td><span
                                    [i18n]="'webhooks-events.documentation.events.types.location-type.chep'"></span>,
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.location-type.cust'"></span>,
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.location-type.UNKNOWN'"></span>
                                </td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.name.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.name.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.coordinates.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_COORDINATES)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.coordinates.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.coordinates.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.address.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_ADDRESS)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.address.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.address.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.timezone.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.location.timezone.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_TRIP_LOCATION"
                         class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.trip-location.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.appointment.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TIMEINTERVAL)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.time-interval.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.appointment.field'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.stop-type.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.stop-type.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.stop-type.data-restriction'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.pickup-time-window.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.label'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.pickup-time-window.description'"></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.appointments.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.label'">
                                    <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TYPED_DATE_RANGED)"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.appointments.description'"></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.delivery-time-window.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.label'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.delivery-time-window.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.contact-details.field'"></td>
                                <td> <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_LOCATION_CONTACT_DETAILS)"
                                       [i18n]="'webhooks-events.documentation.events.types.trip-location-contact-details'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location.contact-details.description'"></td>
                                <td></td>
                            </tr>




                            <tr>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.trip-location.location-extends'"></a>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>


                    <div [id]="DocumentationAnchor.EVENTS_TRIP_TRAILER_DETAILS"
                         class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.number.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.number.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.equipment-type-code.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.equipment-type-code.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.equipment-description.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.equipment-description.description'"></td>
                                    <td></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>



                    <div [id]="DocumentationAnchor.EVENTS_TRIP_LOCATION_CONTACT_DETAILS"
                         class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.trip-location-contact-details.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location-contact-details.name.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location-contact-details.name.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location-contact-details.email.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location-contact-details.email.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location-contact-details.phone.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-location-contact-details.phone.description'"></td>
                                    <td></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>


                    <div [id]="DocumentationAnchor.EVENTS_TRIP_SHIPMENT"
                         class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.leg-number.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.leg-number.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.load-group.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.load-group.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.load-type.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.load-type.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.sales-order-number.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.sales-order-number.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.items.field'"></td>
                                    <td>
                                        <div [i18n]="'webhooks-events.documentation.events.types.array-of'" > </div>
                                        <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_SHIPMENT_ITEMS)"
                                           [i18n]="'webhooks-events.documentation.events.types.array-trip-shipment-items'"></a>
                                    </td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.items.description'"></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_TRIP_SHIPMENT_ITEMS"
                         class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.product-id.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.product-id.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.product-description.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.product-description.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.quantity.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.quantity.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.nominal-weight.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.nominal-weight.description'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment-item.nominal-weight.data-restriction'"></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_COORDINATES" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.coordinates.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.coordinates.latitude.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.double'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.coordinates.latitude.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.coordinates.longitude.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.double'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.coordinates.longitude.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_ADDRESS" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.address.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.address1.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.address1.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.address2.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.address2.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.address3.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.address3.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.city.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.city.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.state.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.state.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.zip.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.zip.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.country.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.address.country.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso3166'"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_TIMEINTERVAL"
                         class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.time-interval.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.time-interval.from.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.time-interval.from.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.time-interval.to.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.time-interval.to.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_CARRIER" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.carrier.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.carrier.name.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.carrier.name.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.carrier.identifier.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.carrier.identifier.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_FIELD_CHANGE"
                         class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.field-change.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.field-change.field.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.field-change.field.description'"></td>
                                <td>
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.description'"></span><br/><br/>

                                    <b><span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.trip-patch.description'"></span></b><br/>
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.trip-patch.origin-appointment-start'"></span>,<br/>
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.trip-patch.origin-appointment-end'"></span>,<br/>
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.trip-patch.dest-appointment-start'"></span>,<br/>
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.trip-patch.dest-appointment-end'"></span>,<br/>
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.trip-patch.load-planning-start'"></span>,<br/>
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.field-change-accepted.trip-patch.load-planning-end'"></span>
                                </td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.field-change.old-value.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.field-change.old-value.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.field-change.new-value.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.field-change.new-value.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_LOAD_DATA" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.load-data.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>

                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.load-id.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.load-id.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.source-id.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.source-id.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.date-ranged.field'"></td>
                                    <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_DATE_RANGED)"
                                           [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.label'"></a>
                                    </td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.date-ranged.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.priority.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.priority.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.sequence-number.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.sequence-number.description'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.scaled-weight.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.scaled-weight.description'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.scaled-weight.data-restriction'"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.service-code.field'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                    <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.service-code.description'"></td>
                                    <td></td>
                                </tr>


                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_DATE_RANGED" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.start.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.start.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.end.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.date-ranged.end.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_COMMON_DATA_TYPED_DATE_RANGED" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.type.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.type.description'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.start.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.start.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.end.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.typed-date-ranged.end.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>


                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY" class="col-md-12 subTitle">
                        <h2 [i18n]="'webhooks-events.documentation.events.delivery'"></h2>
                        <br>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_CHECKIN" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.checkin.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.checkin.type.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.checkin.type.description'"></td>
                                <td><span [i18n]="'webhooks-events.documentation.events.types.stop-type.pick'"></span>,
                                    <span [i18n]="'webhooks-events.documentation.events.types.stop-type.drop'"></span>
                                </td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.checkin.arrival-time.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.checkin.arrival-time.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.checkin.location.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.checkin.location.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ checkInExample | json}}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_CHECKOUT" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.checkout.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.type.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.type.description'"></td>
                                <td><span [i18n]="'webhooks-events.documentation.events.types.stop-type.pick'"></span>,
                                    <span [i18n]="'webhooks-events.documentation.events.types.stop-type.drop'"></span>
                                </td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.departure-time.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.departure-time.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.location.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.location.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.items.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.array-items'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.checkout.items.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <h4 [i18n]="'webhooks-events.documentation.events.common-data.item.label'"></h4>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.origin.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.origin.description'"></td>
                                <td><span
                                    [i18n]="'webhooks-events.documentation.events.types.item-origin.planned'"></span>,
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.item-origin.manually-added'"></span>,
                                    <span
                                        [i18n]="'webhooks-events.documentation.events.types.item-origin.unknown'"></span>
                                </td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.product-code.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.product-code.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.product-description.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.product-description.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.quantity.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.quantity.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.expected-quantity.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.item.expected-quantity.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code"> {{ checkOutExample | json}}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_ETA_UPDATE" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.eta-updated.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.eta.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TIMEINTERVAL)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.time-interval.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.eta.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.confidence-score.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.confidence-score.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.destination-location.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.destination-location.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.driver-coordinates.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_COORDINATES)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.coordinates.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.eta-updated.driver-coordinates.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ etaUpdatedExample | json }}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_BOL_UPDATE" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.bol-updated.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.bol-updated.service-center.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.bol-updated.service-center.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.bol-updated.download-url.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.bol-updated.download-url.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ bolUpdatedExample | json}}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_TRIP_CREATE" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.trip-created.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.direction.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.trip-direction'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.direction.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.direction.data-restriction'"></td>
                            </tr>

                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.description'"></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.external-references.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.external-references.description' "></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.external-references.data-restriction' "></td>
                                <td></td>
                            </tr>


                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-references.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.array-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-references.description'"></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle-description.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle-description.description'"></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle-contact-phone-number.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle-contact-phone-number.description'"></td>
                                <td></td>
                            </tr>

                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.driver-contact-phone-number.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.driver-contact-phone-number.description'"></td>
                                <td></td>
                            </tr>


                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.load-data.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOAD_DATA)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.load-data.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.load-data.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.trip-origin-location.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TRIP_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.trip-location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.trip-origin-location.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.trip-destination-location.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_TRIP_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.trip-location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.trip-destination-location.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.shipment.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_SHIPMENT)" [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.label'"></a></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.shipment.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.loading-duration-in-seconds.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.loading-duration-in-seconds.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.unloading-duration-in-seconds.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.number'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.unloading-duration-in-seconds.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.shipment.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_SHIPMENT)" [i18n]="'webhooks-events.documentation.events.common-data.trip-shipment.label'"></a></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.shipment.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.trailer-details.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_TRIP_TRAILER_DETAILS)" [i18n]="'webhooks-events.documentation.events.common-data.trip-trailer-details.label'"></a></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.trailer-details.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.carrier.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_CARRIER)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.carrier.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.carrier.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ tripCreatedExample | json}}</pre>
                        </div>
                    </div>
                    <br>
                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_TRIP_UPDATE" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.trip-update.label'"></h3>
                        <br>
                        <p [i18n]="'webhooks-events.documentation.events.trip-update.description'"></p>

                        <br>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_TRIP_PATCH" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.trip-patch.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-patch.updated-fields.label'"></td>
                                <td>Array<<a
                                    (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_FIELD_CHANGE)"
                                    [i18n]="'webhooks-events.documentation.events.common-data.field-change.label'"></a>>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-patch.updated-fields.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ tripUpdatedExample | json}}</pre>
                        </div>
                    </div>


                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_TRIP_CLOSED" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.trip-closed.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.load-id.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.load-data.load-id.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-references.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.array-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-references.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.carrier.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_CARRIER)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.carrier.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-created.carrier.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ tripClosedExample | json}}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_DELIVERY_TRIP_CANCEL" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.trip-cancelled.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.trip-id.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.field'"></td>
                                <td>
                                    <a (click)="clickOnTabItem(DocumentationAnchor.TRIP_CANCELLATION_CANCELLATION_INFO)"
                                       [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.label'">
                                    </a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-references.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.array-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.delivery-references.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.load-data.field'"></td>
                                <td>
                                    <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOAD_DATA)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.load-data.label'">
                                    </a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.load-data.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.vehicle.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.carrier.field'"></td>
                                <td>
                                    <a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_CARRIER)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.carrier.label'">
                                    </a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.carrier.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <h4 [id]="DocumentationAnchor.TRIP_CANCELLATION_CANCELLATION_INFO"
                            [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.label'"></h4>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.reason.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.reason.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.source.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.source.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.trip-cancelled.cancellation-info.source.restriction'"></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ tripCancelledExample | json}}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_PGI" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.pgi.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.pgi.delivery-reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.pgi.delivery-reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>

                                <td [i18n]="'webhooks-events.documentation.events.pgi.pgi-date.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.pgi.pgi-date.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ pgi | json}}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_FAILED_COLLECTION" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.failed-collection.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.delivery-reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.delivery-reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.failed-at.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.failed-at.description'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.iso8601'"></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.vehicle.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.vehicle.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.location.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.failed-collection.location.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ failedCollection | json}}</pre>
                        </div>
                    </div>

                    <div [id]="DocumentationAnchor.EVENTS_REVERSE_CHECKIN" class="col-md-12 documentation-item">
                        <h3 [i18n]="'webhooks-events.documentation.events.reverse-checkin.label'"></h3>
                        <br>

                        <table class="table text-left">
                            <thead>
                            <tr>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-field'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-type'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-description'"></th>
                                <th width="25%" [i18n]="'webhooks-events.documentation.events.data-restriction'"></th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.delivery-reference.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.delivery-reference.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.stop-type.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.stop-type.description'"></td>
                                <td><span [i18n]="'webhooks-events.documentation.events.types.stop-type.pick'"></span>,
                                    <span [i18n]="'webhooks-events.documentation.events.types.stop-type.drop'"></span>
                                </td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.carrier.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_CARRIER)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.carrier.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.carrier.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.vehicle.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.vehicle.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.location.field'"></td>
                                <td><a (click)="clickOnTabItem(DocumentationAnchor.EVENTS_COMMON_DATA_LOCATION)"
                                       [i18n]="'webhooks-events.documentation.events.common-data.location.label'"></a>
                                </td>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.location.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.reason.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.reverse-checkin.reason.description'"></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.field'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.types.map-string-string'"></td>
                                <td [i18n]="'webhooks-events.documentation.events.common-data.additional-informations.description'"></td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="documentation-item-darkZone">
                            <pre class="eventData-code">{{ reverseCheckin | json}}</pre>
                        </div>
                    </div>
                </div>
                <!-- END - TAB 5 -->
            </div>
        </div>
    </div>
</div>
